<style scoped>
  .header-bg{background-color:rgb(249,249,249);}
  .container{max-width:1200px;margin: auto;height:59px;line-height:59px;}
  .logo{display: inline-block;height:30px;width:60px;background-size:100% 100%;vertical-align: middle}
  .sys-name{vertical-align:middle;font-size:20px;font-weight:bold;margin-left:15px}
  .avatar-panal{float: right;height: inherit}
  .nav-bg{background-image:url("/img/header/nav-bg.png");background-size:auto 100%;background-repeat: no-repeat}
  .nav-menu{color: white;font-size:14px;font-weight:bold}
  .nav-menu >>> .ivu-menu-light{background:unset;}
  .menu-title {color:white!important;}
  .nav-menu >>> .ivu-menu-item:hover{color:#00a2e9!important;}
  .nav-menu >>> .ivu-menu-submenu:hover{color:#00a2e9!important;}
  .nav-menu >>> .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active{color: #00a2e9;border-bottom: 2px solid #00a2e9;}
  .nav-menu >>> .ivu-menu-horizontal .ivu-menu-item{width:150px;text-align: center;}
  .nav-menu >>> .ivu-menu{z-index: 901}
  .avatar-panal >>> .ivu-select-dropdown{z-index: 902}
</style>
<template>
  <div class="header-bg">
    <div class="container">
      <span class="logo" :style="companyName == '刚峰'?`background-image:url('/img/header/GFlogo.png');`:`background-image:url('/img/header/logo.png');`"></span>
      <span class="sys-name">{{$store.state.userInfo.companyShortName}}</span>
      <div class="avatar-panal">
        <Dropdown>
          <Avatar style="border:1px solid #ffffff" :src="$store.state.userInfo.icon||'https://i.loli.net/2017/08/21/599a521472424.jpg'" size="large" />
          <Icon type="md-arrow-dropdown" />
          <DropdownMenu slot="list">
            <span @click="getUserInfo()"><DropdownItem>个人信息</DropdownItem></span>
            <!--<DropdownItem>修改密码</DropdownItem>-->
            <span @click="logout()"><DropdownItem>退出</DropdownItem></span>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <div class="nav-bg">
      <div class="container nav-menu">
        <Menu mode="horizontal" :active-name="currentUrl" @on-select="setMenuId">
          <template v-for="(item,index) in navigation">
            <Submenu v-if="item.children!=undefined" :name="item.menuId" class="menu-title">
              <template slot="title">
                {{item.title}}
              </template>
              <MenuItem
                  v-for="(secItem,secIndex) in item.children"
                  v-if="secItem&&secItem.state" :name="secItem.menuId"
                  :to="{name:secItem.name}"
              >
                <span :style="parseInt(secItem.state)==0?'color:#ddd':''">{{secItem.title}}</span>
              </MenuItem>
            </Submenu>
						<template v-else>
							<MenuItem
							    :name="item.menuId"
							    v-if="item.state"
							    :to="{name:item.name}"
							    class="menu-title"
							    :style="item.state==0?'color:#ddd':''"
							>
							  <span :style="parseInt(item.state)==0?'color:rgb(100, 100, 100)':''">{{item.title}}</span>
							</MenuItem>
						</template>
          </template>
        </Menu>
      </div>
    </div>
    <Modal
        v-model="userInfo.panelState"
        title="个人信息修改"
        @on-ok="saveInfo()"
    >
      <Row style="line-height:40px;font-size:14px">
        <Col span="5" style="text-align: right">更换头像：</Col>
        <Col span="10">
          <Upload
              :show-upload-list="false"
              :on-success="uploadSuccess"
              style="display: inline-block;vertical-align:middle"
              :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
              :data="{MenuId:menuId,UserId:userId}"
              :action="getServerURL('default',true)">
            <Avatar v-if="userInfo.icon" :src="userInfo.icon" size="large"></Avatar>
            <Avatar v-else size="large">{{userInfo.name[0]}}</Avatar>
          </Upload>
        </Col>
      </Row>
      <Divider dashed />
      <Row style="line-height:40px;font-size:14px">
        <Col span="5" style="text-align: right">用户名称：</Col>
        <Col span="10">
          <Input v-model="userInfo.name"></Input>
        </Col>
      </Row>
      <Divider dashed />
      <Row style="line-height:40px;font-size:14px">
        <Col span="5" style="text-align: right">部门角色：</Col>
        <Col span="10">
          <p>{{$store.state.userInfo.groupName}}</p>
        </Col>
      </Row>
      <Divider dashed />
      <Row style="line-height:40px;font-size:14px">
        <Col span="5" style="text-align: right">律所名称：</Col>
        <Col span="10">
          <p>{{$store.state.userInfo.companyName}}</p>
        </Col>
      </Row>
      <template v-if="oldMobile.state==false">
        <Divider dashed />
        <Row style="line-height:40px;font-size:14px">
          <Col span="5" style="text-align: right">密码：</Col>
          <Col span="19">
            <p>
              <span style="font-size:12px;color:#bbb" @click="getMessage(userInfo.mobile);password.state=true"> 点击修改</span>
            </p>
          </Col>
        </Row>
        <template v-if="password.state">
          <Divider dashed />
          <Row style="line-height:40px;font-size:14px">
            <Col span="5" style="text-align: right">短信验证码：</Col>
            <Col span="19">
              <p>
                <Input style="width:70px;margin-right:5px" v-model="oldMobile.code"></Input>
              </p>
            </Col>
          </Row>
          <Divider dashed />
          <Row style="line-height:40px;font-size:14px">
            <Col span="5" style="text-align: right">新密码：</Col>
            <Col span="19">
              <p>
                <Input style="width:200px;margin-right:5px" type="password" v-model="password.value"></Input>
              </p>
            </Col>
          </Row>
        </template>
      </template>
      <template v-if="password.state==false">
        <Divider dashed />
        <Row v-if="oldMobile.verification==false" style="line-height:40px;font-size:14px">
          <Col span="5" style="text-align: right">手机号码：</Col>
          <Col span="19">
            <p>
              {{userInfo.mobile}}<span style="font-size:12px;color:#bbb" @click="getMessage(userInfo.mobile);oldMobile.state=true"> 修改</span>
              <template v-if="oldMobile.state">
                验证码<Input style="width:70px;margin-right:5px" v-model="oldMobile.code"></Input>
                <Button type="primary" @click="verificationCode(oldMobile.code)">验证</Button>
              </template>
            </p>
          </Col>
        </Row>
        <Divider v-if="oldMobile.verification" dashed />
        <Row style="line-height:40px;font-size:14px" v-if="oldMobile.verification">
          <Col span="5" style="text-align: right">新的手机号码：</Col>
          <Col span="19">
            <Input style="width:150px" v-model="userInfo.newMobile"></Input>
            <Button
                @click="userInfo.mobile==userInfo.newMobile?$Notice.error({title:'系统消息',desc:'无法设置相同的手机号码',}):getMessage(userInfo.newMobile)"
            >
              发送验证码
            </Button>
          </Col>
        </Row>
        <Row v-if="oldMobile.verification" style="line-height:40px;font-size:14px">
          <Col span="5" style="text-align: right">验证码：</Col>
          <Col span="10">
            <Input style="width:70px" v-model="userInfo.code"></Input>
          </Col>
        </Row>
      </template>

    </Modal>
  </div>
</template>

<script>
  export default {
    name: "sysHeader",
    data:function() {
      return {
        currentUrl : parseInt(window.sessionStorage.menuId),
        navigation : [],
        userInfo:{
          panelState:false,
          name:'',
          icon:'',
          id:'',
          mobile:'',
          code:'',
          newMobile:'',
        },
        verificationState:false,
        oldMobile:{
          state:false,
          code:'',
          verification:false,
        },
        password:{
          state:false,
          value:'',
        },
        newMobileMessageState:false,
      }
    },
    methods:{
      verificationCode:function(code){
        var _this= this
        _this.send({
          headers:'U/CodeCheck',
          data:{
            UserId:_this.userId,
            Code:code,
          },
          success:function (res) {
            _this.oldMobile.verification = true
          }
        })
      },
      getMessage: function (mobile) {
        var _this = this
        _this.send({
          headers:'U/UserCode',
          data: {
            PhoneNumber:mobile,
          },
          success: function () {
            _this.$Notice.success({
              title:'系统消息',
              desc:'短信发送成功！'
            })
          }
        })
      },
      uploadSuccess:function (response) {
        this.userInfo.icon = this.getServerURL('default')+'/'+response.Data.path
      },
      saveInfo:function(){
        var _this = this
        if(_this.oldMobile.state==true||_this.password.state==true){
          if(_this.isEmpty(_this.oldMobile.code)){
            _this.$Modal.warning({
              title:'系统提示',
              content:'验证码与新密码不能为空！'
            })
            _this.oldMobile.state=false
            _this.oldMobile.code=''
            _this.oldMobile.verification=false
            _this.password.state=false
            _this.password.value=''
            return
          }
        }
        _this.send({
          headers:'U/UserUpdate',
          data:{
            Code:_this.oldMobile.code,
            PassWord:_this.password.value,
            UserId:_this.userInfo.id,
            Name:_this.userInfo.name,
            PhotoPath:_this.userInfo.icon,
            PhoneNumber:_this.userInfo.newMobile||_this.userInfo.mobile,
          },
          success:function (res) {
            _this.$store.state.userInfo.icon = _this.userInfo.icon
            _this.$store.state.userInfo.fullName = _this.userInfo.name
            window.sessionStorage.userIcon = _this.userInfo.icon
            window.sessionStorage.fullName = _this.userInfo.name
            _this.oldMobile.state=false
            _this.oldMobile.code=''
            _this.oldMobile.verification=false
            _this.password.state=false
            _this.password.value=''
            _this.$Notice.success({
              title:'系统消息',
              desc:'信息修改成功！'
            })
          }
        })
      },
      setMenuId:function(menuId){
        window.sessionStorage.menuId = menuId
        this.currentUrl = menuId
      },
      logout:function () {
        window.sessionStorage.userToken = ''
        window.sessionStorage.phoneNumber = ''
        window.sessionStorage.groupId = ''
        window.sessionStorage.userId = ''
        SYSCONFIG.server.default.data.UserLogin = ''
        SYSCONFIG.server.default.data.UserToken = ''
        SYSCONFIG.server.default.data.GroupId = ''
        window.sessionStorage.menuId = ''
        this.$cookies.remove('userName')
        this.$cookies.remove('password')
        this.$router.push({name:'login'})
      },
      getMenuList:function () {
        var _this = this
        _this.send({
          headers:'P/MenuList',
          warningTips:false,
          success:function (res) {
            var tempArr = []
            var i=0
            var j=0
            for(var index in res){
              tempArr[i] = {}
              tempArr[i].title = res[index].MenuName
              tempArr[i].menuId = res[index].MenuId
              tempArr[i].state = res[index].MenuState
              if(res[index].List!=undefined){
                tempArr[i].children = []
                for(var secIndex in res[index].List){
                  tempArr[i].children[j] = {}
                  tempArr[i].children[j].title = res[index].List[secIndex].MenuName
                  tempArr[i].children[j].name = res[index].List[secIndex].MenuRoute
                  tempArr[i].children[j].menuId = res[index].List[secIndex].MenuId
                  tempArr[i].children[j].state = res[index].List[secIndex].MenuState
                  j++
                }
              }else{
                tempArr[i].name = res[index].MenuRoute
              }
              i++
            }
            _this.navigation = tempArr
          },
          error:function () {
            return
          }
        })
      },
      getUserInfo:function () {
        var _this = this
        _this.send({
          headers:'U/UserInfo',
          data:{
            UserId:window.sessionStorage.userId,
          },
          success:function (res) {
            _this.userInfo.name=res.UserName
            _this.userInfo.icon=res.UserImg
            _this.userInfo.mobile=res.UserMobile
            _this.userInfo.id=res.UserId
            _this.userInfo.panelState = true
          }
        })
      }
    },
    computed:{
			companyName:function(){
				return companyName
			},
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
      userIcon:{
        get:function(){
          return window.sessionStorage.userIcon
        },
        set:function(val){
          window.sessionStorage.userIcon = val
          SYSCONFIG.server.default.data.userIcon = val
        }
      }
    },
    mounted:function () {
      this.getMenuList()
      console.log(this.userIcon)
      this.$store.state.userInfo.icon = this.userIcon
      // this.currentUrl = parseInt(window.sessionStorage.menuId)
    },
  }
</script>
